'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var i18n = {
  zh_CN: {
    noData: '暂无数据'
  },
  en_US: {
    noData: 'No data'
  }
};

var Empty = (_temp = _class = function (_React$Component) {
  _inherits(Empty, _React$Component);

  function Empty() {
    _classCallCheck(this, Empty);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Empty.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: 're-schema-empty' },
      _react2.default.createElement('img', { src: 'https://img.alicdn.com/tfs/TB19HLNSpXXXXXOXVXXXXXXXXXX-32-32.png',
        className: 're-schema-empty-icon',
        alt: ''
      }),
      _react2.default.createElement(
        'span',
        { className: 're-schema-empty-content' },
        i18n[this.props.locale].noData
      )
    );
  };

  return Empty;
}(_react2.default.Component), _class.propTypes = {
  locale: _propTypes2.default.string
}, _class.defaultProps = {
  locale: 'zh_CN'
}, _temp);
exports.default = Empty;
module.exports = exports['default'];